<template>
    <div id="DepreciationSchedule">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> {{pageTitle}}</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="web-action-btn btn-groups text-right">
                        <button id="processPermit" v-if="canPostDepreciation && hideButton === false" v-on:click.prevent="openProcessModal" class="btn btn-secondary"> <i class="fp-process"> </i> Post / Unpost</button>
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link v-if="hideButton === false" class="btn btn-primary" v-bind:to="{name: 'DepriciationCreate',params:{flag:'fromList'}}" >
                            <i class="fp-add"></i>    Add
                        </router-link>
                        <router-link v-if="hideButton === false" class="btn btn-secondary" v-bind:to="{name: 'DepreciationSetupList'}" >
                            <i class="fp-settings"></i>    Rental Configuration
                        </router-link>
                    </div>
                    <div class="mobile-action-btn elipse-btn">
                        <button id="processPermit" v-if="canPostDepreciation  && hideButton === false" v-on:click.prevent="openProcessModal" class="btn btn-secondary"> <i class="fp-process"> </i> Post</button>
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="true" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li>
                                    <a href="javascript:void(0)" class="" v-on:click="exportCheck()"> Export</a>
                                </li>
                                <li>
                                    <router-link v-if="hideButton === false" class="" v-bind:to="{name: 'DepriciationCreate',params:{flag:'fromList'}}" >Add</router-link>
                                </li>
                                <li>
                                    <router-link v-if="hideButton === false" class="btn btn-secondary" v-bind:to="{name: 'DepreciationSetupList'}" >
                                        <i class="fp-settings"></i>    Rental Configuration
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content dep-schedule-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'DepreciationScheduleList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                          <section class="bg-white data-table">
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange" :moduleName="'DepreciationScheduleList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="listDepreciationSchedule"
                                      mode="remote"
                                      title="DepreciationSchedule"
                                      @on-page-change="onPageChange"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'both',
                                          perPage: perPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                          enabled: depreciation_value,
                                          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                          selectionInfoClass: 'custom-class',
                                          selectionText: 'rows selected',
                                          clearSelectionText: 'clear',
                                      }"
                                      >
                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">
                                              <div v-if="props.column.field == 'action'" class='text-center'>
                                                  <template>
                                                      <router-link title="Update Schedule" v-if="props.row.posted =='no'" class="fp-edit" v-bind:to="{name: 'DepriciationEdit',params:{id:props.row.id}}"></router-link>
                                                      <a href="javascript:void(0)" title="Change Status" class="ml-3 fp-settings" v-if="props.row.status =='ENTERED'" v-on:click.prevent="openDepreciation(props.row.id)"></a>
                                                  </template>
                                              </div>
                                                <div v-else-if="props.column.field == 'agreement_no'">
                                                    <span v-fp-html="props.row.agreement_no"></span>
                                                </div>
                                              <div v-else>
                                                  {{props.formattedRow[props.column.field]}}
                                              </div>
                                          </div>
                                      </template>
                                      <div slot="selected-row-actions">
                                          <button id="deleteDepreciationScheduleBtn" v-on:click.prevent="scheduleDelete" class="btn btn-primary">Delete</button>
                                      </div>
                                  </vue-good-table>
                                  <custom-pagination
                                      :page-changed="onPageChange"
                                      :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                        </div>
                        <div class="modal fade add-extra-charge-popup" id="processModal" ref="processModal" data-backdrop="static" data-keyboard="false" aria-labelledby="processModal" aria-hidden="true">
                            <div class="modal-dialog modal-md" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title" id="myModal1">Post Depreciation Schedule </h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="SelectDates" class="addinspectionForm">
                                            <div class="form-row row-cols-md-1 row-cols-1">
                                                <div class="col">
                                                    <label class="control-label require" for="effective_date">Depreciation Posting Date:</label>
                                                    <!-- <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate"></date-picker> -->
                                                    <v-select v-model="effective_date" name="effective_date" placeholder="Select Date."
                                                            label="text"
                                                            :options="dateArr">
                                                    </v-select>
                                                    <div class="field-error">{{ effective_date_error_msg }}</div>
                                                </div>
                                                <div class="col">
                                                    <label class="" for="vehicle_pool_id">Asset Pool:</label>
                                                    <v-select v-model="vehicle_pool_id" name="vehicle_pool_id" placeholder="Select Asset Pool."
                                                            label="text"
                                                            :options="vehiclepoolArr">
                                                    </v-select>
                                                </div>
                                                <div class="col">
                                                    <label class="control-label" for="location_id">Facility:</label>
                                                    <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                            label="text"
                                                            :options="locationArr">
                                                    </v-select>
                                                    <div class="field-error"></div>
                                                </div>
                                                <!-- <div class="example-label permit-label-main">
                                                    <span class="col-md-2"></span>
                                                </div> -->
                                            </div>
                                        </form>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-tertiary" id="cancelprocessDepriciationBtn" data-dismiss="modal">
                                            <i class="fp-close"></i> Cancel
                                        </button>
                                        <button class="btn btn-primary" id="addProcessDepriciationBtn" v-on:click="processDepriciation(false)">
                                            <i class="fp-process"></i> Post
                                        </button>
                                      <button v-if="canUnprocessDepreciation" class="btn btn-primary" id="addProcessDepriciationBtn" v-on:click="processDepriciation(true)">
                                        <i class="fp-process"></i> Unpost
                                      </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from ".././event-bus";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import moment from 'moment';


    export default {
        name: "DepreciationScheduleList",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "DepreciationSchedule List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],

        data: () => ({
            pageTitle: "Depreciation Schedule List",
            depreciation_value: true,
            hideButton:false,
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Action',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: '# Unit',
                    field: 'unit_no',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Schedule Type',
                    field: 'schedule_type',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Schedule Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Method',
                    field: 'method',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Method", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Capital Amount',
                    field: 'capital_amount',
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Capital Amount", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Depreciation Rate',
                    field: 'depriciation_rate',
                    fpFieldType:"integer",
                    type:'number',
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Depreciation Rate", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Initial Residual',
                    field: 'initial_residual',
                    fpFieldType:"integer",
                    type:'number',
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Initial Residual", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Start Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Depreciation Schedule Term',
                    field: 'duration',
                    fpFieldType:"integer",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Depr Schedule Term", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Active Contract',
                    field: 'agreement_no',
                    filterable: false,
                    hidden:false,
                    fpFieldType:"text",
                    html:true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Unit", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    sortable:false
                },
                {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Depr Schedule Term", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Entered','Open','Posted','Closed'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: 'id',
                    type: 'desc',
                },
                page: 1,
                perPage: 10
            },
            loading:false,
            selectedFile:"",
            error:"",
            pageKey:"_depreciation_schedule_list_",
            action:'list',
            effective_date:'',
            vehicle_pool_id:'',
            location_id:'',
            locationArr:[],
            vehiclepoolArr:[],
            effective_date_error_msg:'',
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: false,
            },
            canPostDepreciation:false,
            canUnprocessDepreciation:false,
            dateArr:[],
            batchProcess:0,
            batchNum:"",
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_depreciation_schedule') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'post_asset_depreciation') {
                            self.canPostDepreciation = true;
                        }
                        if (permissions[i].name == 'unpost_gl') {
                          self.canUnprocessDepreciation = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },

        mounted: function() {
            var self = this;
            //self.loadList();

            //when component list directly call from url instead of in view page than call permission request
            self.getPermissions();
            self.loadVehicleSearchData();
            // this.loadFieldData(['depriciation_type']);
            if(self.$route.query.flag == 'depreciationReport'){
              self.hideButton = true;
              self.depreciation_value = false;
              self.pageTitle = "Depreciation Review";

              for (let index = 0; index < this.columns.length; index++) {

                  if(this.columns[index].field == 'action'){
                      this.$set(this.columns[index], 'hidden', true);
                  }
              }

            }

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listDepreciationSchedule.unselectAllInternal();
            },
            exportCheck: function() {
                var self = this;
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['listDepreciationSchedule'].selectedRows;
                count = data.length;

                if(this.serverParams.selectedAll == true){
                    actionFlag = "";
                }else if(count != 0 && count <= 100){
                    actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            openModal: function(){
                var self = this;
                // $('#importFileBtn').text('Import');
                self.notFoundArr = [];
                self.selectedFile = "";
                self.error = "";
                self.notfound = false;
                $("#typeImage").val('');
                $('#myModal').modal('show');
            },

            loadList() {
                var self = this;
                self.loading = true;
                 var selectedRows = [];

                //because on first load list not initialize
                var data = this.$refs['listDepreciationSchedule'].selectedRows;
                for ( var i = 0; i < data.length; i++ ) {
                    selectedRows.push(this.$refs['listDepreciationSchedule'].selectedRows[i].id)
                }

                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    action: self.action,
                    selectedRows:selectedRows,
                    selectedAll:self.serverParams.selectedAll

                };
                self.firstLoad = 1;

                $.ajax({
                    url: process.env.ROOT_API + "/depreciation-schedule/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            if ( self.action == "export" ||  self.action == "export_queue") {
                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                                self.loadList();

                            } else {

                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;

                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'asset-inventory-list')

                    }
                });
            },
            openProcessModal: function(){
                var self = this;

                self.effective_date = '';
                self.effective_date_error_msg = '';
                self.vehicle_pool_id ='';
                self.location_id = '';
                self.getLastDateofmonth();
                $("#processModal").modal('show');
            },

            // As per the requirement on 15/09/2023, change the deployment workflow and comment the code below
            // process_Depriciation:function(isUnprocess){
            //     var self = this;
            //     var vehicle_pool_id = '';
            //     var location_id = '';
            //     if ( self.effective_date == ''){
            //         self.effective_date_error_msg = 'Date Required';
            //         return;
            //     }
            //     if ( self.vehicle_pool_id != null && self.vehicle_pool_id != undefined){
            //         vehicle_pool_id = self.vehicle_pool_id;
            //     }
            //     if ( self.location_id != null && self.location_id != undefined){
            //         location_id = self.location_id;
            //     }
            //     if (isUnprocess) {
            //         $("#addProcessDepriciationBtn").val("Process");
            //         $("#addProcessDepriciationBtn").prop("disabled", false);
            //         Swal.fire({
            //         title: 'Are you sure?',
            //         text: "You want to unpost depreciation",
            //         icon: 'warning',
            //         showCancelButton: true,
            //         confirmButtonColor: '#3085d6',
            //         cancelButtonColor: '#d33',
            //         confirmButtonText: 'Yes'
            //         }).then((result) => {
            //             if (result.value) {
            //                 var url = '&effective_date='+self.effective_date+'&pool_id='+vehicle_pool_id+'&loc_id='+location_id+'&isReverse='+isUnprocess;
            //                 $("#processModal").modal('hide');
            //                 self.$router.push({ name: 'DepreciationPreview', query: { data : btoa(url) }});
            //                 return;
            //             }
            //         });
            //     }else{
            //         $("#addProcessDepriciationBtn").val("Process");
            //         $("#addProcessDepriciationBtn").prop("disabled", true);
            //         self.loading = true;
            //         $.ajax({
            //             url: process.env.ROOT_API + "/depriciation-preview/post",
            //             type: "POST",
            //             data: {
            //                 effective_date:self.effective_date,
            //                 pool_id:vehicle_pool_id,
            //                 location_id:location_id,
            //                 is_reversal:isUnprocess,
            //             },
            //             headers: {
            //                 'Accept': 'application/json',
            //                 "Authorization": "Bearer " + localStorage.getItem("tkn"),
            //                 'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
            //                 "Cache-Control": "no-cache"
            //             },
            //             dataType: 'json',
            //             success: function (data) {
            //                 self.loading = false;
            //                 if (data.status == "success") {
            //                     if (data.code == '200') {
            //                         console.log("here batchId" ,data.batchId);
            //                         var url =
            //                         '&effective_date=' + self.effective_date +
            //                         '&pool_id=' + vehicle_pool_id +
            //                         '&loc_id=' + location_id +
            //                         '&batchId=' + data.batchId;

            //                         $("#processModal").modal('hide');
            //                         self.$router.push({ name: 'DepreciationPreview', query: { data: btoa(url) }});
            //                         return;
            //                         // self.$router.push('/depreciation-schedule/list');
            //                     }

            //                 }else{
            //                     self.$swal('',data.content,'info');
            //                 }
            //             },
            //             error: function (jqXHR, exception) {
            //                 self.loading = false;
            //                 $("#addProcessDepriciationBtn").val("Process");
            //                 $("#addProcessDepriciationBtn").prop("disabled", false);
            //                 self.generateStatusCodeMessage(jqXHR,true,'permit-import-error')

            //             }
            //         });
            //     }

            // },
            processDepriciation: function(isUnprocess){
                var self = this;
                self.effective_date_error_msg = '';
                var vehicle_pool_id = '';
                var location_id = '';
                if ( self.effective_date == ''){
                    self.effective_date_error_msg = 'Date Required';
                    return;
                }

                if ( self.vehicle_pool_id != null && self.vehicle_pool_id.value){
                    vehicle_pool_id = self.vehicle_pool_id.value;
                }
                if ( self.location_id != null && self.location_id.value){
                    location_id = self.location_id.value;
                }

                if (isUnprocess) {

                    Swal.fire({
                    title: 'Are you sure?',
                    text: "You want to unpost depreciation",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes'
                    }).then((result) => {

                        if (result.value) {

                            var url = '&effective_date='+self.effective_date+'&pool_id='+vehicle_pool_id+'&loc_id='+location_id+'&isReverse='+isUnprocess;
                            $("#processModal").modal('hide');
                            self.$router.push({ name: 'DepreciationPreview', query: { data : btoa(url) }});
                            return;

                            // $("#addProcessDepriciationBtn").val("Processing ...");
                            // $("#addProcessDepriciationBtn").prop("disabled", true);
                            // $.ajax({
                            // url: process.env.ROOT_API + "/depriciation-schedule/post",
                            // type: "POST",
                            // data: {
                            //     // fields:this.$refs['listPermitTable'].selectedRows,
                            //     effective_date:self.effective_date,
                            //     pool_id:vehicle_pool_id,
                            //     location_id:location_id,
                            //     is_reversal:isUnprocess,
                            // },
                            // headers: {
                            //     'Accept': 'application/json',
                            //     "Authorization": "Bearer " + localStorage.getItem("tkn"),
                            //     'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                            //     "Cache-Control": "no-cache"
                            // },
                            // dataType: 'json',
                            // success: function (data) {
                            //     self.loading = false;
                            //     setTimeout(function () {
                            //     $(".alert-success").removeClass("show");
                            //     $(".alert-success").addClass("hide");
                            //     }, 10000);

                            //     if (data.code == '200') {
                            //     $("#processModal").modal('hide');
                            //     self.loadList();
                            //     }
                            //     $("#addProcessDepriciationBtn").val("Process");
                            //     $("#addProcessDepriciationBtn").prop("disabled", false);
                            // },
                            // error: function (jqXHR, exception) {
                            //     self.loading = false;
                            //     $("#addProcessDepriciationBtn").val("Process");
                            //     $("#addProcessDepriciationBtn").prop("disabled", false);
                            //     self.generateStatusCodeMessage(jqXHR,true,'permit-import-error')

                            // }
                            // });
                        }
                    });

                }else{
console.log("here745");
                    var url = '&effective_date='+self.effective_date+'&pool_id='+vehicle_pool_id+'&loc_id='+location_id;
                    $("#processModal").modal('hide');
                    self.$router.push({ name: 'DepreciationPreview', query: { data : btoa(url) }});
                    return;

                    // $("#addProcessDepriciationBtn").val("Processing ...");
                    // $("#addProcessDepriciationBtn").prop("disabled", true);
                    // $.ajax({
                    // url: process.env.ROOT_API + "/depriciation-schedule/post",
                    // type: "POST",
                    // data: {
                    //     // fields:this.$refs['listPermitTable'].selectedRows,
                    //     effective_date:self.effective_date,
                    //     pool_id:vehicle_pool_id,
                    //     location_id:location_id,
                    //     is_reversal:isUnprocess,
                    // },
                    // headers: this.ajxHeaders,
                    // dataType: 'json',
                    // success: function (data) {
                    //     self.loading = false;
                    //     setTimeout(function () {
                    //     $(".alert-success").removeClass("show");
                    //     $(".alert-success").addClass("hide");
                    //     }, 10000);

                    //     if (data.code == '200') {
                    //     $("#processModal").modal('hide');
                    //     self.loadList();
                    //     }
                    //     $("#addProcessDepriciationBtn").val("Process");
                    //     $("#addProcessDepriciationBtn").prop("disabled", false);
                    // },
                    // error: function (jqXHR, exception) {
                    //     self.loading = false;
                    //     $("#addProcessDepriciationBtn").val("Process");
                    //     $("#addProcessDepriciationBtn").prop("disabled", false);
                    //     self.generateStatusCodeMessage(jqXHR,true,'permit-import-error')

                    // }
                    // });
                }
            },
            loadVehicleSearchData() {

                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/asset/search",
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: 'json',
                    success: function (data) {

                        if (data.status == "success") {

                            self.locationArr = data.location;
                            self.vehiclepoolArr = data.vehiclepool;
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        if (jqXHR.status == 0) {
                            self.registerError = "Remote server cannot be reached";
                        }
                    }
                });
            },
            getLastDateofmonth:function(){
                var self = this;

                var date = new Date();
                var newdate = new Date();
                var arr = [];
                for(var i = 3; i > 0;i--){
                    var momentDate = moment(date).subtract(i, 'months').format('MM/DD/YYYY');
                    arr.push(moment(momentDate).endOf('month').format('MM/DD/YYYY'));
                    // arr.push(moment(date).subtract(i, 'months').format('MM/DD/YYYY'));
                }
                for(var j = 0; j <= 3;j++){
                    var momentDate = moment(newdate).add(j, 'months').format('MM/DD/YYYY');
                    arr.push(moment(momentDate).endOf('month').format('MM/DD/YYYY'));
                }
                self.dateArr = arr;
                console.log(self.dateArr);
            },
            scheduleDelete:function(){
                var self = this;
                var data = this.$refs['listDepreciationSchedule'].selectedRows;
                var scheduleId = [];
                var check = 0;
                for (var i = 0; i < data.length; i++) {
                    if(data[i].posted == 'yes'){
                      check = 1;
                      break;
                    }
                    scheduleId.push(data[i].id);
                }
                // console.log("list of IDS =", scheduleId);
                if (check == 1) {
                    self.$swal('','Please select only those schedules which are not posted yet !!','info');
                }else{
                  if (confirm('Are you sure that you want to delete this Depreciation Schedule? ')) {
                      self.loading = true;

                      $.ajax({
                          url: process.env.ROOT_API + "/depreciation-schedule/delete",
                          type: "POST",
                          data: 'id=' + scheduleId,
                          headers: this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              if (data.status == "success") {
                                self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                              self.loading = false;
                              self.generateStatusCodeMessage(jqXHR,false,'depreciation-schedule-deletion')

                          }
                      });
                  }
                }
            },
            openDepreciation:function(id){
                var self = this;
                if (confirm('Are you sure that you want to open this Depreciation Schedule? ')) {
                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/depreciation-schedule/open",
                        type: "POST",
                        data:{
                            id:id
                        },
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success") {
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,false,'depreciation-schedule-open')

                        }
                    });
                }
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/asset/DepreciationScheduleList.vue